<template>
  <el-dialog
    title="编辑会员"
    :visible="true"
    width="750px"
    @close="handleClose"
    :lock-scroll="false"
    :append-to-body="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-container>
      <el-main>
        <el-form :model="form" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="账号">
                <el-input v-model="form.account" readonly>
                  <template slot="append">
                    <el-select
                      v-model="form.isEnable"
                      placeholder="状态"
                      style="width: 75px"
                    >
                      <el-option :value="true" label="启用"></el-option>
                      <el-option :value="false" label="停用"></el-option>
                    </el-select>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密码">
                <el-input
                  v-model="form.password"
                  type="password"
                  show-password
                  placeholder="不修改请留空"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机号">
                <el-input v-model="form.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱">
                <el-input v-model="form.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司名">
                <el-input v-model="form.company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目名">
                <el-input v-model="form.projectname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="项目描述">
            <el-input type="textarea" v-model="form.projectdescribe"></el-input>
          </el-form-item>
          <el-form-item label="查看产品">
            <el-checkbox-group v-model="form.productids">
              <el-checkbox
                border
                v-for="product in products"
                :label="product.id"
                :key="product.id"
                >{{ product.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-main>
      <el-footer class="chead">
        <el-button type="primary" round @click="editUserContent()"
          >保存</el-button
        >
      </el-footer>
    </el-container>
  </el-dialog>
</template>
<script>
import { getAuthValue, edituserextend } from "../../../api/gm/api-user";
import { editUser } from "../../../api/main/api-user";
export default {
  data() {
    return {
      authvalue: "", //授权值
      form: this.Content, //会员数据
      products: this.Products, //产品数据
    };
  },
  props: {
    Content: {
      type: Object,
    },
    Products: {
      type: Array,
    },
  },
  created() {
    getAuthValue(this.form.pid).then((res) => {
      if (res.code === 0) {
        if (res.data != undefined) {
          this.authvalue = res.data.value;
        }
      } else {
        console.log(res.msg);
      }
    });
  },
  methods: {
    //..关闭弹窗
    handleClose() {
      this.$emit("hide");
    },
    //..修改会员
    editUserContent() {
      if (this.form.account.trim() === "") {
        this.$message.error("请输入账号");
      } else {
        let userformData = new FormData(); //会员基础数据
        userformData.append("id", this.form.id);
        userformData.append("pid", this.form.pid);
        userformData.append("account", this.form.account);
        userformData.append("password", this.form.password);
        userformData.append("name", this.form.name);
        if (this.form.phone !== null) {
          userformData.append("phone", this.form.phone);
        }
        if (this.form.email !== null) {
          userformData.append("email", this.form.email);
        }
        userformData.append("value", this.authvalue);
        userformData.append("isEnable", this.form.isEnable);
        userformData.append("image", this.form.image);
        userformData.append("eSign", this.form.eSign);
        let userExtentformData = new FormData(); //会员扩展数据
        userExtentformData.append("account", this.form.account);
        userExtentformData.append("company", this.form.company);
        userExtentformData.append("projectname", this.form.projectname);
        userExtentformData.append("projectdescribe", this.form.projectdescribe);
        let arr = this.form.productids;
        if (arr.lenght < 1) {
          userExtentformData.append("productids", null);
        } else {
          for (let i = 0; i < arr.length; i++) {
            //假设这个数组对应的字段为box
            userExtentformData.append("productids", arr[i]);
          }
        }

        editUser(userformData).then((res) => {
          if (res.code === 0) {
            edituserextend(userExtentformData).then((resd) => {
              this.$emit("refresh");
              if (resd.code === 0) {
                this.$confirm("编辑成功,是否继续编辑?", "提示", {
                  confirmButtonText: "继续",
                  cancelButtonText: "取消",
                  type: "success",
                  lockScroll: false,
                  callback: (action) => {
                    if (action !== "confirm") {
                      this.handleClose();
                    }
                  },
                });
              } else {
                this.$message.error(resd.msg);
              }
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.el-dialog {
  margin-top: 5vh !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/userextend/edit.vue